import { compose, Store } from "redux";
import { configureStore } from '@reduxjs/toolkit'
import * as Types from "../types";
import reducer from "../reducers";
// import { isDevelopmentMode } from "../configuration/configuration";

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// const composeEnhancers = isDevelopmentMode() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = configureStore({ reducer });

const getStore = (): Store<Types.IState, Types.IAction> => store;

export default getStore;
